import { Container, Divider } from "@material-ui/core";
import { Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  ButtonGroupTop,
  CustomTable,
  DateRangePicker,
  DateTimeDisplay,
  ModalError,
  Page,
  SectionLabel,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatPayloadDate, getErrors } from "utils";

function Aktifitas() {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
    action_id: 0,
    start_date: moment(),
    end_date: moment(),
  });
  const [optionAction, setOptionAction] = useState([]);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleResetPage = () => handleChangeQueryParams(1, "page");
  const handleChangeRowsPerPage = event => {
    const { value } = event?.target;
    handleChangeQueryParams(value, "size");
    handleResetPage();
  };
  const getActionList = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/log/log-action`, { headers });
      const modifiedData = res?.data?.data?.map(item => ({
        label: item.action_name,
        id: item.log_action_id,
      }));
      setOptionAction(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataTable = async () => {
    setLoadingPage(true);
    const params = {
      ...queryParams,
      start_date: formatPayloadDate(queryParams?.start_date),
      end_date: formatPayloadDate(queryParams?.end_date),
    };
    try {
      const res = await axios.get(`${hardBaseUrl}/publisher/log`, {
        headers,
        params,
      });
      const { data, meta } = res?.data;
      setDataTable(data);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getActionList();
  }, []);
  useEffect(() => {
    getDataTable();
  }, [queryParams]);

  return (
    <Page className={classes.root} title="Activity">
      <Container maxWidth={false}>
        <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my={2}
        >
          <Grid item>
            <SectionLabel
              title="Activity"
              subTitle="Display a list of user activity logs."
            />
          </Grid>
          <Grid item>
            <Grid container columnSpacing={1}>
              <Grid item>
                <AutoCompleteComponent
                  options={optionAction}
                  label="Select Action"
                  value={
                    optionAction.find(
                      option => option.id === queryParams?.action_id
                    ) || null
                  }
                  onChange={value =>
                    handleChangeQueryParams(value, "action_id")
                  }
                  size="small"
                />
              </Grid>
              <Grid item>
                <DateRangePicker
                  label="Date Range"
                  startDate={queryParams?.start_date}
                  handleChangeStartDate={date =>
                    handleChangeQueryParams(date, "start_date")
                  }
                  endDate={queryParams?.end_date}
                  handleChangeEndDate={date =>
                    handleChangeQueryParams(date, "end_date")
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, data) => handleChangeQueryParams(data, "page")}
          handleChangePageSize={handleChangeRowsPerPage}
        />
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/aktifitas",
  },
  {
    label: "Activty",
    active: true,
  },
];
const columnTable = [
  {
    name: "all",
    title: "Date",
    renderText: item => (
      <DateTimeDisplay
        date={moment(
          `${item?.date} ${item?.time}`,
          "D-MMM-YYYY hh:mm:ss A"
        ).format()}
      />
    ),
  },
  {
    name: "all",
    title: "Account",
    renderText: item => (
      <div>
        <Typography fontSize={14} fontWeight={500}>
          {item?.created_by_name}
        </Typography>
        <Typography variant="body2">{item?.created_by_email}</Typography>
      </div>
    ),
  },
  {
    name: "action",
    title: "Action",
  },
  {
    name: "content",
    title: "Description",
  },
];
export default Aktifitas;
